import { Button } from "@chakra-ui/button"
import { useAccent1, useAccent2, useAccent6, useBackground, useForeground } from "src/modeAwareColors"

function ButtonSwitch({ isSelected, ...rest }) {
  const fg = useForeground()
  const bg = useBackground()
  const two = useAccent2()
  const a2 = useAccent2()

  return (
    <Button
      variant='group'
      bg={isSelected ? a2 : bg}
      borderColor={isSelected ? fg : two}
      zIndex={isSelected ? 9 : 0}
      borderRadius='99px'
      fontSize='sm'
      {...rest}
    />

  )
}

export default ButtonSwitch
